import { EntityExtraTagsRequestRules } from '../../../EntityExtraTags'

export function toBirdviewRequestCountersExtra(requests) {
  return {
    items: requests.map(({ counters, id }) => ({
      [EntityExtraTagsRequestRules.ActiveAutomationsCount]:
        counters.active_automations,
      [EntityExtraTagsRequestRules.ChatMessagesCount]: counters.chat_messages,
      [EntityExtraTagsRequestRules.EmailsCount]: counters.emails,
      [EntityExtraTagsRequestRules.FilesCount]: counters.files,
      [EntityExtraTagsRequestRules.UnreadChatMessagesCount]:
        counters.unread_chat_messages,
      [EntityExtraTagsRequestRules.UnreadEmailsCount]: counters.unread_emails,
      id,
    })),
  }
}
